import {
  Box,
  Button,
  Drawer,
  Stack,
  styled,
  TextField,
  Typography,
} from "@mui/material";

import { INFO_PANEL_MAX_WIDTH } from "../../../../utils/constants/styles.constants";
export const DistributionDetailPanel = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    borderTopLeftRadius: theme.spacing(1),
    marginTop: theme.spacing(1),
    minWidth: INFO_PANEL_MAX_WIDTH,
    maxWidth: INFO_PANEL_MAX_WIDTH,
  },
}));

export const DistributionTitleBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(4),
}));

export const DistributionFormBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  maxHeight: "calc(100vh - 200px)",
  overflow: "auto",
}));

export const DistributionLinkButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 700,
  fontSize: "16px",
  width: "70%",
}));

export const DistributionStyledTextField = styled(TextField)(({ theme }) => ({
  width: "48%",
}));

export const DistributionStyledStack = styled(Stack)(({ theme }) => ({
  width: "48%",
}));

export const DistributionAmountTextField = styled(TextField)(({ theme }) => ({
  width: "24%",
}));

export const DistributionStyledTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(-3),
  marginBottom: theme.spacing(2),
}));
